<template>
    <div class="col span_3_of_12 span_4_of_12-tl span_4_of_12-tp span_4_of_12-sl span_12_of_12-sp mb-4rem-sp lw-course-contents-chapter fsh-0" @click="sectionClicked" :class="sectionWrapperClass">
        <div class="with-flexible-parts align-items-center">
            <div class="learnworlds-main-text learnworlds-main-text-huge learnworlds-element">
                {{sectionNumber}}
            </div>
            <div class="ml-10px lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny" v-if="displayAccessLabel && sectionAccess !== 'premium'">{{sectionDisplayedAccessLabel}} </div>

            <!-- drip feed -->
            <div class="ml-20px with-flexible-parts align-items-center" v-if="dripFeedTagsDisplay">
                <span class="mr-10px small learnworlds-icon no-margin-bottom fas fa-lock"></span>
                <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDripDateLabel}}</div>
            </div>
            <!----->

        </div>
        <h3 class="mt-4rem learnworlds-heading3 learnworlds-heading3-large learnworlds-element lw-course-contents-chapter-name">{{sectionTitle}}</h3>
        <div class="mt-4rem lw-course-contents-units">
            <div class="lw-course-contents-unit with-flexible-parts align-items-center p-5px-0" v-for="unit,index in sectionUnits" @click="unitClicked(unit,...arguments)">
                <unit-icon class="lw-contents-svg small" :icon="unit.icon"></unit-icon>

                <div class="ml-10px no-margin-bottom learnworlds-main-text learnworlds-main-text-small learnworlds-element">
                    {{unit.title}}
                </div>
                <div class="ml-10px nowrap no-margin-bottom lw-text-color-fadeout50 learnworlds-main-text learnworlds-main-text-small learnworlds-element" v-if="getFullUnitData(unit) && getUnitExtraInfo(unit)">
                    {{getUnitExtraInfo(unit)}}
                </div>
                <span class="ml-10px no-margin-bottom learnworlds-main-text-small learnworlds-icon fas fa-paperclip" v-if="unit.attachments && unit.attachments.length"></span>
                <span class="ml-10px no-margin-bottom learnworlds-main-text-small learnworlds-icon fas fa-check" v-if="unitCompleted(unit)"></span>
            </div>
        </div>
    </div>

</template>

<script>
    import CourseContentsTemplateMixin from "../../mixins/CourseContentsTemplateMixin";
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseContentsTemplate21",
        mixins: [CourseContentsTemplateMixin,ComponentTemplatesMixin],
    }
</script>

